import type { IEmbloomQuestionnaire } from '../../interfaces/embloomQuestionnaire';
import { translateKey } from '../../../translate';
import {
    AdminTable,
    InputCheckbox,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableRow,
} from '../../elements/common';

interface IEmbloomQuestionnaireServiceOrganizationSettingTableProps {
    changeSelection: (value: boolean, id: string) => void;
    embloomQuestionnaireSelection: string[];
    questionnaires: IEmbloomQuestionnaire[];
}

export function EmbloomQuestionnaireServiceOrganizationSettingTable(
    props: IEmbloomQuestionnaireServiceOrganizationSettingTableProps
) {
    return (
        <AdminTable tableLayoutFixed>
            <TableHead>
                <TableRow>
                    <TableHeader colspan={1}></TableHeader>
                    <TableHeader colspan={2}>{translateKey('embloomQuestionnaires.abbreviation')}</TableHeader>
                    <TableHeader colspan={6}>{translateKey('common.name')}</TableHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.questionnaires.map((item) => (
                    <TableRow key={item.id}>
                        <TableData colspan={1}>
                            <InputCheckbox
                                checked={props.embloomQuestionnaireSelection.includes(item.id)}
                                onChange={(value) => props.changeSelection(value, item.id)}
                            />
                        </TableData>
                        <TableData colspan={2}>{item.label}</TableData>
                        <TableData colspan={6}>{item.description}</TableData>
                    </TableRow>
                ))}
            </TableBody>
        </AdminTable>
    );
}
